import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {  TEAM_MEMBERS_LIST_COUNT } from "../../../consts/queries";
import { executeQuery } from "../../../requests/executeQuery";
import  filter  from "../../../filter";

const initialState = {
    loading: true, data: [], error: null
}

// Generates pending, fulfilled and rejected action types
export const fetchTeamMembers = createAsyncThunk('TeamMember/fetchTeamMembers', () => {
    const query = { };
    const options = filter(query, 'team-member');
    return  Promise.all([
        executeQuery({ queryName: TEAM_MEMBERS_LIST_COUNT, options: options })]).then((response) => {
           return response[0].data;
        })
})

const teamMemberSlice = createSlice({
    name: 'teamMember',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchTeamMembers.pending, state => {
            state.loading = true;
        })
        builder.addCase(fetchTeamMembers.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = '';
        })
        builder.addCase(fetchTeamMembers.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message
        })
    }
})
export default teamMemberSlice.reducer;
